/**
 * FGA relation constants
 *
 * Keep in sync with admin_middleware/src/admin_middleware/services/fga/authorization.py
 */

export type FgaRelation = 'member' | 'developer' | 'admin';

// selectable via UI. `member` will only exist post FGA enforcement or view-only UI
export type SelectableFgaRelation = 'admin' | 'developer';
export const SELECTABLE_FGA_RELATIONS: SelectableFgaRelation[] = [ 'admin', 'developer' ];

// auth0 roles to fga. godmode collapses to admin
export const ROLE_TO_FGA: Record<string, FgaRelation> = {
  godmode: 'admin',
  admin: 'admin'
};

// Inverse direction
export const FGA_TO_AUTH0_ROLE: Record<SelectableFgaRelation, string | null> = {
  admin: 'admin',
  developer: null
};

